import React, { PropTypes, Component } from 'react'
import R from 'ramda'
import Promise from 'bluebird'
import {
  unslugify,
  sortArray,
  isUserFavorite,
  numberWithCommas
} from '../../Utils'
import {
  searchCategories,
  searchCities,
  findProperties
} from '../../sources/SearchSource'
import SearchResult from './SearchResult'
import Key from '../../svg-icons/Key'

import showBackButton from '../../components/showBackButton'

let capitalize = d =>
  d.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })

class SearchCityDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      parent: {},
      properties: [],
      canLoadMore: true,
      isFetching: false,
      categories: [],
      keys: [
        {
          title: 'Favorite',
          key: 'favorite',
          accessor: d => {
            return isUserFavorite(this.props.user, d) ? (
              <Key />
            ) : (
              <Key className='notFavorite' />
            )
          },
          sortAccessor: d => isUserFavorite(this.props.user, d),
          width: 80,
          sort: null
        },
        {
          title: 'Title',
          key: 'title',
          width: 300,
          className: 'title',
          sort: null
        },
        {
          title: 'Continent',
          key: 'continent',
          width: 150,
          sort: null
        },
        {
          title: 'Country',
          key: 'country',
          width: 150,
          sort: null
        },
        {
          title: 'City',
          key: 'city',
          width: 200,
          sort: null
        },
        {
          title: 'Category',
          key: 'category',
          width: 250,
          accessor: d => d.category.name,
          sort: null
        },
        {
          title: 'Keys',
          key: 'noRooms',
          width: 100,
          sort: null
        },
        {
          title: 'Portfolio',
          key: 'portfolio',
          width: 100,
          accessor: d => (d.portfolio ? 'Yes' : 'No'),
          sort: null
        },
        {
          title: 'Price',
          key: 'price',
          width: 100,
          unit: '€',
          accessor: d => numberWithCommas(d.price),
          sortAccessor: d => d.price,
          sort: null
        },
        {
          title: 'Yield',
          key: 'yield',
          width: 100,
          unit: '%',
          sort: null
        },
        {
          title: 'Area',
          key: 'area',
          width: 100,
          unit: 'm2',
          accessor: d => numberWithCommas(d.area),
          sortAccessor: d => d.area,
          sort: null
        }
      ]
    }
    this.searchProperties = this.searchProperties.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.handleSort = this.handleSort.bind(this)
  }

  componentWillMount () {
    const { location } = this.props
    window.addEventListener('resize', this.updateDimensions)
    Promise.all([ searchCategories(), searchCities({ id: location.query.id }) ])
      .spread((categoriesResponse, cityResponse) => {
        this.setState(
          { categories: categoriesResponse.data, parent: cityResponse.data },
          () => this.searchProperties()
        )
      })
      .catch(console.error)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions () {
    this.forceUpdate()
  }

  searchProperties () {
    const { properties, categories, parent } = this.state
    const { continent, country, city } = this.props.params

    let capitalizedCountry = capitalize(country)
    let capitalizedCity = capitalize(city)
    let capitalizedContinent = capitalize(continent)

    this.setState({ isFetching: true }, () => {
      let settings = {
        preferredCities: [ parent ],
        minInvestment: 0,
        minYield: 0,
        minNoRooms: 0,
        published: true,
        sold: false
      }
      findProperties({ settings, skip: properties.length })
        .then(response => {
          let { results, noResults } = response.data
          if (noResults > 0) {
            const newProperties = results.map((el, index) => {
              el.city = capitalizedCity
              el.country = capitalizedCountry
              el.continent = capitalizedContinent
              categories.forEach(category => {
                if (category.id === el.category) {
                  el.category = category
                  return
                }
              })
              return el
            })
            const list = R.sortBy(
              R.prop('title'),
              R.union(properties, newProperties)
            )
            this.setState({
              properties: list,
              canLoadMore: results.length < noResults,
              isFetching: false
            })
          } else {
            this.setState({ canLoadMore: false, isFetching: false })
          }
        })
        .catch(console.error)
    })
  }

  handleSort (el) {
    const keys = R.clone(this.state.tableHeaderKeys)
    const keyIndex = R.findIndex(R.propEq('title', el.title), keys)
    const result = sortArray(el, this.state.properties)
    keys.forEach(el => {
      el.sort = null
    })
    keys[keyIndex] = result.sortKey
    this.setState({ properties: result.list, tableHeaderKeys: keys })
  }

  render () {
    const { city, continent, country } = this.props.params
    const { canLoadMore, isFetching, properties, keys, parent } = this.state
    const { propertyDetails, router } = this.props
    const title = unslugify(city)
    const path = {
      continent: unslugify(continent),
      country: unslugify(country),
      city: unslugify(city)
    }

    return (
      <SearchResult
        type={'city'}
        router={router}
        path={path}
        propertyDetails={propertyDetails}
        isFetching={isFetching}
        handleClick={propertyDetails}
        results={properties}
        title={title}
        tableKeys={keys}
        handleSort={this.handleSort}
        loadMore={this.searchProperties}
        canLoadMore={canLoadMore}
        parent={parent}
      />
    )
  }
}

SearchCityDetails.propTypes = {
  user: PropTypes.object,
  updatePath: PropTypes.func,
  propertyDetails: PropTypes.func,
  params: PropTypes.object,
  location: PropTypes.object,
  router: PropTypes.object
}

export default showBackButton(SearchCityDetails)



// WEBPACK FOOTER //
// ./src/pages/Search/SearchCityDetails.js